module.exports = __webpack_public_path__ + "img/placeholder.c6278523.jpeg";